import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panel-air-cooler',
  templateUrl: './panel-air-cooler.component.html',
  styleUrls: ['./panel-air-cooler.component.scss']
})
export class PanelAirCoolerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
